module.exports = __webpack_public_path__ + "logo_log.svg?de5797f58ae4d432066f74ca3ef876f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_log.svg
// module id = 337
// module chunks = 1